import { Grid } from '@mui/material';
import { MprcIconButtonDropdown } from 'components';
import { ButtonAdd } from 'components/buttons';
import { MprcFilterBox, MprcFilterLine } from 'components/filter';
import { IconButtonCancel } from 'components/iconButtons';
import { IconSort } from 'components/icons';
import { MprcDropdownItems } from 'components/MprcIconButtonDropdown';
import { MprcTextFieldColor } from 'components/MprcTextFieldColor';
import { FeedListQueryOrderBy, PublicationListType } from 'generated/CoreApi_v1';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////////////////////

export enum PublicationType {
    PublicationType = 0,
    trainingType = 1,
}

export interface IFeedListFilterOptions {
    searchText: string;
    orderBy: FeedListQueryOrderBy;
}

interface IProps {
    listType?: PublicationListType;
    filterOptions: IFeedListFilterOptions;
    onAdd?: (publicationType: PublicationType) => void;
    onFilterChange: (filter: IFeedListFilterOptions) => void;
}

export const FeedListFilter: React.FC<IProps> = (props) => {

    const { filterOptions, onAdd, onFilterChange } = props;
    const { t } = useTranslation("knowledge");

    const [searchText, setSearchText] = useState<string>(filterOptions.searchText ?? "");

    const inputRef = useRef<HTMLInputElement | undefined>(undefined);

    ///
    const handleButtonCancel = () => {
        setSearchText("");
        onFilterChange({ ...filterOptions, searchText: "" });
    };

    ///
    const getMenuItems = (): MprcDropdownItems<FeedListQueryOrderBy> => {
        const menu: MprcDropdownItems<FeedListQueryOrderBy> = [
            { text: t("Feed.List.OrderBy.DisplayOrder"), value: FeedListQueryOrderBy.DisplayOrder },
            { text: t("Feed.List.OrderBy.MostRecent"), value: FeedListQueryOrderBy.MostRecent },
            { text: t("Feed.List.OrderBy.MostViewed"), value: FeedListQueryOrderBy.MostViewed },
            { text: t("Feed.List.OrderBy.MostLiked"), value: FeedListQueryOrderBy.MostLiked }
        ];

        return menu;
    };

    useEffect(() => {
        if (!filterOptions.searchText && searchText) {
            setSearchText("");
        }
    }, [filterOptions]);

    return (
        <MprcFilterBox>
            <MprcFilterLine>
                <div>
                    {
                        onAdd &&
                        <ButtonAdd
                            size="large"
                            text={t("Feed.Card.List.AddButtonText")}
                            color="inherit"
                            onClick={() => onAdd(PublicationType.PublicationType)}
                        />
                    }
                </div>

                <div>
                    <MprcIconButtonDropdown
                        menuItemCheck
                        icon={<IconSort />}
                        title={t("shared:Filter.OrderBy")}
                        selected={filterOptions.orderBy}
                        onChange={(orderBy) => onFilterChange({ ...filterOptions, orderBy })}
                        items={getMenuItems()}
                    />
                </div>

            </MprcFilterLine>

            <Grid container>
                <Grid size="grow">
                    <MprcTextFieldColor
                        fullWidth
                        placeholder={t("Feed.Card.List.SearchTextPlaceholder")}
                        inputColor="warning"
                        underlineColor="warning"
                        autoFocus
                        autoComplete="off"
                        value={searchText}
                        inputRef={(ref) => inputRef.current = ref}
                        onChange={(e) => setSearchText(e.currentTarget.value)}
                        onKeyDown={(e) => { if (e.keyCode == 13) onFilterChange({ ...filterOptions, searchText }); }}
                        endAdornment={
                            searchText == ""
                                ? null
                                : <IconButtonCancel color="warning" size="small" onClick={handleButtonCancel} />
                        }
                    />
                </Grid>
            </Grid>

        </MprcFilterBox>
    );
};
